import "./index.css";
import { useTranslation } from "react-i18next";

export const ProductIntro = () => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        marginLeft: "50px",
      }}
      className="product-intro-bg"
    >
      <h5
        style={{
          color: "#664650",
          fontWeight: "bold",
          marginBottom: "23px",
          fontSize: "14px",
        }}
      >
        {t("TELL_US_ABOUT_PRODUCT")}
      </h5>
      <p
        style={{
          color: "#664650",
          fontSize: "12px",
        }}
      >
        {t("PRODUCT_MAPPING_DESCRIPTION")}
      </p>
    </div>
  );
};
